<template >
  <v-dialog eager  fullscreen class="dialogo" transition="dialog-bottom-transition" v-model="dialog">
   <v-card class="cardCarosello" color="black">
     <v-toolbar flat color="secondary" dark>
       <v-toolbar-title>Foto</v-toolbar-title>
       <v-spacer></v-spacer>
       <v-toolbar-items>
         <v-btn text dark v-if="latLng.length > 0" @click="openStreetView">Google Street view</v-btn>
         <v-btn text dark @click="close()">Close</v-btn>
       </v-toolbar-items>
     </v-toolbar>
     <v-card-text>
       <table class="tabella">
         <tr>
           <td colspan="2">
             <div class="toolControl">
               <div class="rotateControl">
                 <v-icon x-large color="gray" title="Ruota a sinistra" @click="rotate(-90)">mdi-rotate-left</v-icon>
                 <v-icon x-large color="gray" title="Ruota a destra" @click="rotate(90)">mdi-rotate-right</v-icon>
               </div>
               <div class="zoomControl">
                 
                 <v-slider dense hide-details  v-model="scale" min="0.1" max="3.0" step="0.05" color="orange" 
                 :label="''+Math.trunc((Math.round(scale*100)/100)*100)+'%'"
                   @change="scaleImage()"></v-slider>
               </div>
               <div class="currentFotoTag">
                 <v-chip color="rgb(157, 152, 152);" style="color: rgb(243, 239, 239);" label >{{ currentFoto.tag }}</v-chip>
               </div>
               
             </div>
           </td>
           <td class="tdAdd">
             <v-btn hidden @click="addFoto()">Agg. foto MONTAGGIO</v-btn>
             <!--NB questo FOR SERVE PER riuscire a passare il paramettro rilievo in handleNewFileUpload. Non so perchè ma all'interno del metodo this.rilievo non funziona -->
             <div v-for="rilievoOrNi in rilieviOrNi" v-bind:key="rilievoOrNi.uniqueId">
               <input hidden type="file" id="fileNewPhoto"
                 @change="handleNewFileUpload($event, rilievoOrNi, 'MONTAGGIO')">
             </div>
           </td>
           <td><div>
                 
               </div></td>
         </tr>
         <tr>
           <td class="tdCurrent">
             <div class="noFoto" v-show="foto.length == 0">Nessuna foto presente</div>
             <div class="scroll-container" id="box">
             
<img  draggable="false" 
:style="'scale:'+scale+' '+getStyleRotation(currentFoto)" 
:src="getUrl(currentFoto,1500)"
alt="current image" >
</div>
           </td>
           <td class="tdFotoContainer">
   
                    
               
             <div class="fotoContainer">
               <div class="fotoPreviewContainer" 
               v-show="foto.length > 0" v-for=" (f,i) in foto" :key="'fotoprdfff'+i">
                 <div class="imagePreviewTag">
                   <v-chip color="rgb(157, 152, 152);" 
                    style="color: rgb(243, 239, 239);" 
                   label >{{ f.tag }}</v-chip>
                 </div>
                 <div>
     

                   <img @click="setCurrentFoto(f)" 
                   :style="getStyleRotation(f)" 
                   :src="getUrl(f,200)"
                     :class="currentFoto == f ? 'active fotoPreview' : 'fotoPreview'">
                     
                 </div>
               </div>
             </div>
           </td>
           <td></td>
         </tr>
       </table>
       <!--galleria foto-->
     </v-card-text>
     <v-card-actions class="justify-end">
     </v-card-actions>
   </v-card>
 </v-dialog>

</template>
<script>
import { rilieviApi } from '../services/RilieviApi';
import { imgApi } from '../services/ImgApi';
import { utils } from "../services/Utils";


export default {
components: {},
name: "PhotoCarusel",
props: {




},
computed: {
 style() {
   return { transform: 'rotate(' + this.turn + 'deg)' }
 }
},

data() {
 return {
   rotations:[],
   scale: 1,
   rilieviOrNi: [],//serve solo per definirlo nell'interfaccia, perchè altrimenti non funziona l'aggiunta di file
   rilievoOrNi: {},
   newPhoto: {},
   mode: 'RILIEVO',
   MODES: { RILIEVO: 'RILIEVO', NC: 'NC' },
   turn: 0,
   rotazione: 0,
   foto: [],
   currentFoto: {},
   dialog: false,
   latLng: [],
   googleUrl: '',
  currentImgId:0
 };
},

created() {


},
mounted() {
 const box = document.getElementById('box');

let isDown = false;
let startX;
let startY;
let scrollLeft;
let scrollTop;

box.addEventListener('mousedown', (e) => {
isDown = true;
startX = e.pageX - box.offsetLeft;
startY = e.pageY - box.offsetTop;
scrollLeft = box.scrollLeft;
scrollTop = box.scrollTop;
box.style.cursor = 'grabbing';
});

box.addEventListener('mouseleave', () => {
isDown = false;
box.style.cursor = 'grab';
});

box.addEventListener('mouseup', () => {
isDown = false;
box.style.cursor = 'grab';
});

document.addEventListener('mousemove', (e) => {
if (!isDown) return;
e.preventDefault();
const x = e.pageX - box.offsetLeft;
const y = e.pageY - box.offsetTop;
const walkX = (x - startX) * 1; // Change this number to adjust the scroll speed
const walkY = (y - startY) * 1; // Change this number to adjust the scroll speed
box.scrollLeft = scrollLeft - walkX;
box.scrollTop = scrollTop - walkY;
});
},
beforeMount() {

},

methods: {
 scaleImage(){

 },
 eliminaFoto(){
   //alert(this.currentFoto.hash);
   rilieviApi.deleteFoto(this.currentFoto.hash).then(()=>{
     
     utils.removeFromArray(this.foto, this.currentFoto);
     if (this.foto.length>0){
      this.currentFoto=this.foto[0]; 
     }else{
       this.currentFoto={};
     }
   });
 },

 
 
 setCurrentFoto(f){
this.currentFoto=f;

       },

 close() {
   this.$emit('close', this.foto);
   this.dialog = false;
   this.clear();
 },
 onPhotoAdded(f) {
   //alert('fotoadded:'+JSON.stringify(f));
   this.newPhoto = f;
 },

 addFoto() {
   document.getElementById('fileNewPhoto').click();
 },
 handleNewFileUpload(event, rilievo, photoSubType) {
   var f = event.target.files[0];
   if (this.mode == this.MODES.RILIEVO) {
     rilieviApi.insertFoto('RILIEVO', photoSubType, rilievo.uniqueId, f).then(x => {
       var newFoto = [];
       imgApi.formatFoto(x, newFoto);
       this.updatePhotoList(newFoto);

     });
   } else {

     rilieviApi.insertFoto('NE', photoSubType, "" + rilievo.prgNe, f).then(x => {

       var newFoto = [];
       imgApi.formatFoto(x, newFoto);
       this.updatePhotoList(newFoto);

     });
   }

 },
 getRotation(f){
   for (let index = 0; index < this.rotations.length; index++) {
     const element = this.rotations[index];
     if (element.foto==f){
       return element.rotation;
     }
   }
   return 0;
 },
 getStyleRotation(f){
   var r=this.getRotation(f);
   var ret= " ;transform: rotate(" + r + "deg)" ;
 //  alert(ret);
   return ret;
 
 },
 getUrl(f,size){
 //  var rotation=this.getRotation(f);
   return f.url + '/'+size+'/0';
 },
 rotate(t){
   var f=this.currentFoto;
   this.rotazione=this.rotazione+t;
   var found=false;
   for (let index = 0; index < this.rotations.length; index++) {
     const element = this.rotations[index];
     if (element.foto==f){
       element.rotation=element.rotation+t;
       found=true;
       break;
     }
   }
   if (found==false){
     var r={foto:f,rotation:t};
     this.rotations.push(r);
   }
 },
 clear() {
   /*var canvas = this.$refs.ref_canvas;
   const ctx = canvas.getContext("2d");
   ctx.clearRect(0, 0, canvas.width, canvas.height);*/
   this.foto = [];
   this.currentFoto = {};
   this.rotazione=0;
   this.scale=1;
   this.rotations=[];

 },
 updatePhotoList(x) {
   //alert(JSON.stringify(x));
   this.foto = x;

   if (x.length > 0) {
     
     this.setCurrentFoto(x[0]);
      
   }
 },
 openStreetView() {
   window.open(this.googleUrl, '_blank', 'noreferrer');
 },
 openWithRilievo(f, latLng, r) {
   this.open(this.MODES.RILIEVO, f, latLng, r);
 },
 openWithNi(f, latLng, ni) {
   // alert(JSON.stringify(f));
   this.open(this.MODES.NC, f, latLng, ni);

 },
 open(mode, f, latLng, r) {
   this.rilievoOrNi = r;

   this.mode = mode
   //NB questo array rilievi SERVE PER riuscire a passare il paramettro rilievo in handleNewFileUpload.
   //vedi html v-for rilievo in rilievi
   // Non so perchè ma all'interno del metodo this.rilievo non funziona 
   this.rilieviOrNi = [];
   this.rilieviOrNi.push(this.rilievoOrNi);
   

   this.dialog = true;


   if (latLng) {
     this.latLng = latLng;
     this.googleUrl = "https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=" + this.latLng[0] + ',' + this.latLng[1];
   } else {
     this.latLng = [];
     this.googleUrl = 'https://www.google.com/maps/';
   }
   
 
       
         this.updatePhotoList(f);
 
 },


},
};
</script>
<style scoped>
.fotoContainer {
display: flex;
flex-wrap: wrap;
justify-content: left;
;
width: 22rem;
height: 10rem;
border: 0px solid red;
}

.imagePreviewTag {
width: 10rem;

}

.fotoPreview {
height: 10rem;
width: 10rem;
border: 0px solid gray;
object-fit: contain;
margin: 6px;
}

.currentFoto {
height: 10rem;
width: 10rem;
border: 1px solid gray;
object-fit: contain;
}

.tdFotoContainer {

vertical-align: top;
}

.active {
border: 2px solid white;
}

.tabella {
margin-top: 0.2rem;
margin-left: 1rem;
overflow: scroll;
}

.toolControl {
padding: 0;
display: flex;
width: 55rem !important;
;
justify-content: space-between;



border: 0px solid gray;
;
vertical-align: bottom;
}

.zoomControl {
border: 0px solid gray;
;
margin-top: 0.58rem;
margin-left: 0.1rem;
width: 20rem;
display: flex;

padding-left: 0rem;
padding-right: 0rem;
}

.currentFotoTag {
margin-top: 0.58rem;
}

.rotateControl {
border: 0px solid gray;
;
margin-top: 0;
margin-bottom: 0.3rem;

}

.tabella {

width: 98%;
}

.tabella td {
border: 0px solid red;
}

.tdCurrent {
width: 20rem;
}

.tdAdd {

width: 10rem;
}

.plus {
font-size: 1.2rem;
font-weight: 400;
color: orange;
}
.fotoPreviewContainer{
border:0px solid red;
align-content: center;
text-align: center;
}

div.scroll-container {
background-color: #333;
overflow: auto;
width:55rem;
height:35rem;
white-space: nowrap;
padding: 10px;
display: flex;
justify-content: center;
}

div.scroll-container img {
padding: 10px;


}
</style>